import * as Axios from '../api/axios';

const notify = function (dispatch, errorData, type) {
  dispatch({
    type: type || 'ERROR',
    payload: errorData,
  });
};

// eslint-disable-next-line import/prefer-default-export
export const getPaymentOrder = (id) => {
  return (dispatch) => {
    dispatch({
      type: 'FETCHING_ORDER',
    });
    return Axios.getPaymentOrder(id).then((order) => {
      dispatch({
        type: 'FETCHED_ORDER',
        payload: order,
      });
    }, (error) => {
      notify(dispatch, { error });
    });
  };
};
